import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'

import { IGrade, ISubject } from 'interfaces'

type CreateSubThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateSubTheme: React.FC<CreateSubThemeProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()

  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values?.theme_id) {
      values.name = values?.name?.trim()
      const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'sub_themes')
      if (isNameRepeated && isNameRepeated?.sub_themes?.length === 0) {
        return (
          formProps.onFinish &&
          formProps.onFinish({
            ...values,
            created_by: user?.id,
          })
        )
      } else {
        message.error("Can't add Sub-theme with repeated name...")
      }
    } else {
      message.error('expected values are missing...')
    }
  }
  return (
    <Modal {...modalProps} title="Create Sub Theme">
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('sub_themes', 'create', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Sub Theme Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Theme" name="theme_id" rules={[{ required: true }]}>
          <Select {...subjectSelectProps} />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
